const s = require("./title.module.scss");

import * as React from "react";
import classnames from "classnames";

interface TitleProps {
    text: string;
    className?: string;
}

const Title = ({ text, className }: TitleProps) => {
    const classes = classnames(
        className,
        s.title
    );
    return <span className={classes}>{text}</span>;
};

export default Title;